import { FIELD_TYPES } from './field-types';
export const DEFAULT_FIELD_LABEL_LIMIT = 255;
export const DEFAULT_FIELD_RICOS_LABEL_LIMIT = 500;
export const DEFAULT_FIELD_PLACEHOLDER_LIMIT = 100;
export const DEFAULT_SORTABLE_LIST_ITEM_LABEL_LIMIT = 400;
export const DEFAULT_FIELD_DESCRIPTION_LIMIT = 500;
export const DEFAULT_RICOS_CONTENT_LIMIT = 20000;
export const DEFAULT_MIN_CHARACTER_LIMIT = 0;
export const DEFAULT_MAX_CHARACTER_LIMIT = 5000;
export const DEFAULT_DEXT_FIELD_LIMIT = 50;
export const DEFAULT_DEXT_MAX_TEXT_INPUT_LENGTH = 200;
export const DEFAULT_DEXT_MAX_TEXT_AREA_LENGTH = 400;
export const DEFAULT_DEXT_TAGS_ITEMS_LIMIT = 9;
export const DEFAULT_DEXT_TAGS_ITEM_LENGTH = 100;
export const DEFAULT_DEXT_TAGS_OTHER_LABEL_LENGTH = 50;
export const DEFAULT_DEXT_TAGS_OTHER_INPUT_LENGTH = 50;
export const DEFAULT_DEXT_CHECKBOX_GROUP_ITEMS_LIMIT = 9;
export const DEFAULT_DEXT_CHECKBOX_GROUP_ITEM_LENGTH = 100;
export const DEFAULT_DEXT_CHECKBOX_GROUP_OTHER_LABEL_LENGTH = 50;
export const DEFAULT_DEXT_CHECKBOX_GROUP_OTHER_INPUT_LENGTH = 50;
export const DEFAULT_DEXT_RADIO_GROUP_ITEM_LENGTH = 200;
export const DEFAULT_DEXT_RADIO_GROUP_OTHER_LABEL_LENGTH = 100;
export const DEFAULT_DEXT_RADIO_GROUP_OTHER_INPUT_LENGTH = 100;
export const DEFAULT_DEXT_DROPDOWN_ITEM_LENGTH = 200;
export const MAX_INTERNAL_NAME_LENGTH = 64;
export const MAX_SUBMIT_BUTTON_TEXT_LENGTH = 65;
export const MAX_FILE_UPLOAD_BUTTON_TEXT_LENGTH = 50;
export const MAX_EXPLANATION_TEXT_LENGTH = 200;
export const MIN_FILES = 1;
export const MAX_FILES = 30;
export const DONATION_OPTIONS_LIMIT = 100;
export const PRODUCT_OPTIONS_LIMIT = 100;
export const MAX_PRODUCT_LABEL_LENGTH = 80;
export const MAX_EVENT_NAME_LENGTH = 50;
export const DEFAULT_OPTION_LIMIT = 300;
export const DEFAULT_OPTION_LABEL_LENGTH_LIMIT = 400;
export const DEFAULT_OTHER_OPTION_LABEL_MAX_LENGTH = 350;
export const DEFAULT_OTHER_OPTION_PLACEHOLDER_MAX_LENGTH = 100;
export const EVENTS_RSVP_OPTION_LIMIT = 2;
export const DEXT_FIELD_TYPE_TO_MAX_LENGTH = {
  [FIELD_TYPES.DEXT_TEXT_INPUT]: DEFAULT_DEXT_MAX_TEXT_INPUT_LENGTH,
  [FIELD_TYPES.DEXT_TEXT_AREA]: DEFAULT_DEXT_MAX_TEXT_AREA_LENGTH,
  [FIELD_TYPES.DEXT_URL_INPUT]: DEFAULT_DEXT_MAX_TEXT_INPUT_LENGTH,
  [FIELD_TYPES.DEXT_DROPDOWN]: DEFAULT_DEXT_MAX_TEXT_INPUT_LENGTH,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: DEFAULT_DEXT_MAX_TEXT_INPUT_LENGTH
};
export const OPTION_LABEL_LENGTH_LIMIT = {
  [FIELD_TYPES.DROPDOWN]: DEFAULT_OPTION_LABEL_LENGTH_LIMIT,
  [FIELD_TYPES.RADIO_GROUP]: DEFAULT_OPTION_LABEL_LENGTH_LIMIT,
  [FIELD_TYPES.CHECKBOX_GROUP]: DEFAULT_OPTION_LABEL_LENGTH_LIMIT,
  [FIELD_TYPES.TAGS]: DEFAULT_OPTION_LABEL_LENGTH_LIMIT,
  [FIELD_TYPES.DEXT_DROPDOWN]: DEFAULT_DEXT_DROPDOWN_ITEM_LENGTH,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: DEFAULT_DEXT_RADIO_GROUP_ITEM_LENGTH,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: DEFAULT_DEXT_CHECKBOX_GROUP_ITEM_LENGTH,
  [FIELD_TYPES.DEXT_TAGS]: DEFAULT_DEXT_TAGS_ITEM_LENGTH,
  [FIELD_TYPES.QUIZ_IMAGE_CHOICE]: DEFAULT_OPTION_LABEL_LENGTH_LIMIT,
  [FIELD_TYPES.EVENTS_RSVP]: DEFAULT_OPTION_LABEL_LENGTH_LIMIT
};
export const OPTION_LIMIT = {
  [FIELD_TYPES.DROPDOWN]: DEFAULT_OPTION_LIMIT,
  [FIELD_TYPES.RADIO_GROUP]: DEFAULT_OPTION_LIMIT,
  [FIELD_TYPES.CHECKBOX_GROUP]: DEFAULT_OPTION_LIMIT,
  [FIELD_TYPES.TAGS]: DEFAULT_OPTION_LIMIT,
  [FIELD_TYPES.DEXT_DROPDOWN]: DEFAULT_OPTION_LIMIT,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: DEFAULT_OPTION_LIMIT,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: DEFAULT_DEXT_CHECKBOX_GROUP_ITEMS_LIMIT,
  [FIELD_TYPES.DEXT_TAGS]: DEFAULT_DEXT_TAGS_ITEMS_LIMIT,
  [FIELD_TYPES.EVENTS_RSVP]: EVENTS_RSVP_OPTION_LIMIT
};
//# sourceMappingURL=default-limits.js.map